import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ProductsPage = lazy(() => import('../pages/products/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const StudyPage = lazy(() => import('../pages/study/page'));
const LegalPage = lazy(() => import('../pages/legal/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const CookiesPage = lazy(() => import('../pages/cookies/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/nos-produits',
    element: <ProductsPage />,
  },
  {
    path: '/nos-services',
    element: <ServicesPage />,
  },
  {
    path: '/etude-gratuite',
    element: <StudyPage />,
  },
  {
    path: '/mentions-legales',
    element: <LegalPage />,
  },
  {
    path: '/politique-de-confidentialite',
    element: <PrivacyPage />,
  },
  {
    path: '/politique-de-cookies',
    element: <CookiesPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
